import { OnInit } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
var MapPanelComponent = /** @class */ (function () {
    function MapPanelComponent() {
        this.center = [];
    }
    Object.defineProperty(MapPanelComponent.prototype, "mapRef", {
        set: function (map) {
            var _this = this;
            if (!map)
                return;
            this.bounds = new google.maps.LatLngBounds();
            this.markers.forEach(function (m) { return _this.bounds.extend(m.location); });
            map.fitBounds(this.bounds);
        },
        enumerable: true,
        configurable: true
    });
    MapPanelComponent.prototype.ngOnInit = function () {
        this.markers = this.data.markers.value || [];
        if (!window.hasOwnProperty('google')) {
            this.loadGoogleMapScript();
        }
        else {
            this.showMap = true;
        }
    };
    MapPanelComponent.prototype.loadGoogleMapScript = function () {
        var _this = this;
        var url = "https://maps.googleapis.com/maps/api/js?key=" + this.data.apiKey;
        var script = document.createElement('script');
        script.src = url;
        script.onload = function () { return _this.showMap = true; };
        document.head.appendChild(script);
    };
    return MapPanelComponent;
}());
export { MapPanelComponent };
